import { makeAutoObservable } from "mobx";

import Janus from "../utils/janus";

import StreamingStore from "./janus-plugins/Streaming.store";
import VideoRoomStore from "./janus-plugins/VideoRoom.store";

class JanusStore {
  janusInstance = null;

  streamingStore = null;

  videoRoomStore = null;

  janusConfig = null;

  tracksHandler = null;

  userNameToDisplay = "";

  oldScreensArray = [];

  constructor(janusConfig, tracksHandler, userName, oldScreensArray) {
    makeAutoObservable(this);
    this.janusConfig = janusConfig;
    this.tracksHandler = tracksHandler;
    this.userNameToDisplay = userName;
    this.oldScreensArray = oldScreensArray;
    this.janusConfig !== null && this.initJanus();
  }

  initJanus() {
    Janus.init({
      debug: "all",
      callback: () => {
        if (!Janus.isWebrtcSupported()) {
          console.error("No WebRTC support...");
          return;
        }
        this.janusInstance = new Janus({
          server: this.janusConfig.server,
          success: () => {
            // Instantiating the store for each plugin and passing the track handler
            this.streamingStore = new StreamingStore(this, this.tracksHandler, this.oldScreensArray);
            this.videoRoomStore = new VideoRoomStore(this, this.userNameToDisplay, this.janusConfig);
            this.streamingStore.attach();
            this.videoRoomStore.attach();
          },
          error: (error) => {
            console.error("Janus initialization error:", error);
          },
          destroyed: () => {
            console.log("Janus instance destroyed");
          },
        });
      },
    });
  }

  cleanup() {
    if (this.streamingStore) {
      this.streamingStore.detach();
    }
    if (this.videoRoomStore) {
      this.videoRoomStore.leave();
    }
    if (this.janusInstance) {
      this.janusInstance.destroy();
    }
  }
}

export default JanusStore;
